module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-campaign-page"
  }, [_c('div', {
    staticClass: "message-section"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_title_message')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageTitle),
      expression: "messageTitle"
    }],
    staticClass: "input message-title-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_enter_email_title')
    },
    domProps: {
      "value": (_vm.messageTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enTitle),
      expression: "enTitle"
    }],
    staticClass: "input message-title-input section-top-xs",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_enter_email_title_en')
    },
    domProps: {
      "value": (_vm.enTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "section-title section-top-sm"
  }, [_vm._v(_vm._s(_vm.locale.t('label_send_message')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageText),
      expression: "messageText"
    }],
    staticClass: "input message-input",
    attrs: {
      "placeholder": _vm.locale.t('label_enter_email_text'),
      "rows": "3"
    },
    domProps: {
      "value": (_vm.messageText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enText),
      expression: "enText"
    }],
    staticClass: "input message-input section-top-xs",
    attrs: {
      "placeholder": _vm.locale.t('label_enter_email_text_en'),
      "rows": "3"
    },
    domProps: {
      "value": (_vm.enText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageUrl),
      expression: "imageUrl"
    }],
    staticClass: "input message-title-input section-top-xs",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_campaign_image_url')
    },
    domProps: {
      "value": (_vm.imageUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-options"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendByEmail),
      expression: "sendByEmail"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendByEmail) ? _vm._i(_vm.sendByEmail, null) > -1 : (_vm.sendByEmail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendByEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sendByEmail = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sendByEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sendByEmail = $$c
        }
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.locale.t('label_send_by_email')) + "\n      ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendByNotification),
      expression: "sendByNotification"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendByNotification) ? _vm._i(_vm.sendByNotification, null) > -1 : (_vm.sendByNotification)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendByNotification,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sendByNotification = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sendByNotification = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sendByNotification = $$c
        }
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.locale.t('label_send_by_notification')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "message-actions"
  }, [_c('button', {
    staticClass: "send-button",
    on: {
      "click": _vm.sendCampaign
    }
  }, [_vm._v("\n        " + _vm._s(_vm.locale.t('label_send')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "selected-counter"
  }, [_vm._v("\n        " + _vm._s(_vm.locale.t('label_selected_companies')) + ": " + _vm._s(_vm.selectedCompanyIds.length) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "company-tools"
  }, [_c('div', {
    staticClass: "company-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input filter-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "companies"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "company-action-buttons"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.clickSearch()
      }
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(_vm._s(_vm.locale.t('label_do_search')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.toggleSelectAll()
      }
    }
  }, [_c('i', {
    staticClass: "ti-check"
  }), _vm._v("\n        " + _vm._s(_vm.allFilteredSelected ? _vm.locale.t('label_unselect_all') : _vm.locale.t('label_select_all')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "72px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_picture')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_companies')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "170px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_current_balance')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_select')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredCompany), function(company, index) {
    return _c('tr', {
      key: company.id
    }, [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_serial_num')
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_picture')
      }
    }, [(company.logoUrl) ? _c('img', {
      staticClass: "cropped1 user-avatar-sm",
      attrs: {
        "src": company.logoUrl
      }
    }) : _c('img', {
      staticClass: "cropped1-missing user-avatar-sm",
      attrs: {
        "src": require("../../assets/img/icons/missing_image.svg")
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "company-name-cell",
      attrs: {
        "data-title": _vm.locale.t('label_companies')
      }
    }, [_vm._v("\n                " + _vm._s(company.displayName || company.name) + "\n              ")]), _vm._v(" "), _c('td', {
      style: (_vm.getBalanceStyle(company)),
      attrs: {
        "data-title": _vm.locale.t('label_current_balance')
      }
    }, [_vm._v("\n                " + _vm._s(company.currentBalance) + " €\n              ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_select')
      }
    }, [_c('input', {
      key: company.id,
      attrs: {
        "type": "checkbox",
        "id": 'cmp-' + company.id
      },
      domProps: {
        "checked": _vm.setSelectedCheckCompany(company)
      },
      on: {
        "change": function($event) {
          return _vm.onChangeCheckCompany(company)
        }
      }
    })])])
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b5ee17ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaign/CompanyCampaign.vue
// module id = 843
// module chunks = 0